export const GET_CONTRIBUTORS_REQUESTED = 'GET_CONTRIBUTORS_REQUESTED';
export const GET_CONTRIBUTORS_SUCCESS = 'GET_CONTRIBUTORS_SUCCESS';
export const GET_CONTRIBUTORS_FAILED = 'SIGN_IN_USER_FAILED';



// WEBPACK FOOTER //
// ./src/app/store/github/github.mutations.types.ts